import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  Building,
  Room,
  StorageUnit
} from '@app/components/spremiste2D/util/item';
import { NtapGlobalConstants, Util } from '@ntap/core';
import { PrimeNGTableComponent } from '@ntap/primeng';

@Component({
  selector: 'app-spremiste2d',
  templateUrl: './spremiste2d.component.html',
  styleUrls: ['./spremiste2d.component.scss']
})
export class Spremiste2DComponent
  extends PrimeNGTableComponent
  implements OnInit
{
  private router = inject(Router);

  currentView: 'buildings' | 'prostorije' | 'jedinice' | 'lokacije';
  currentBuilding: Building | null = null;
  currentRoom: Room | null = null;
  currentStorageUnit: StorageUnit | null = null;

  oldViewName = 'spremiste_objekti';
  oldViewState = {};
  oldView: 'buildings' | 'prostorije' | 'jedinice' | 'lokacije';

  ngOnInit() {
    this.loadBuildings();
  }

  loadBuildings() {
    this.listViewProvider.viewName = 'spremiste_objekti';
    this.listViewProvider.viewState = {};
    this.currentView = 'buildings';
  }
  test(data: any) {
    // this.totalRecords =
    //   data.length > 0 ? data[0][ViewStateData.ITEMS_COUNT] : 0;
    console.log(data);
  }

  vratiNaProstorije(parentItem: any) {
    this.listViewProvider.viewName = 'spremiste_prostorije';
    this.listViewProvider.viewState = {
      $parentId: parentItem['earhiv~spremiste_prostorija~spremiste_objekt_id'],
      $parentType: 'earhiv~spremiste_objekt',
      $mainType: 'earhiv~spremiste_prostorija'
    };
    this.currentView = 'prostorije';
  }
  vratiNaJedinicu(parentItem: any) {
    this.listViewProvider.viewName = 'spremiste_spremisne-jedinice';
    this.listViewProvider.viewState = {
      $parentId:
        parentItem[
          'earhiv~spremiste_spremisna_jedinica~spremiste_prostorija_id'
        ],
      $parentType: 'earhiv~spremiste_prostorija',
      $mainType: 'earhiv~spremiste_spremisna_jedinica'
    };
    this.currentView = 'jedinice';
  }
  navigateToTablicni(): void {
    this.router.navigateByUrl('/view/spremiste_objekti');
  }
  vrati() {
    this.currentView = this.oldView;
    this.listViewProvider.viewName = this.oldViewName;
    this.listViewProvider.viewState = this.oldViewState;
  }
  handleClick(
    view: 'buildings' | 'prostorije' | 'jedinice' | 'lokacije',
    viewName: string,
    parentItem: any,
    parentType: string,
    mainType?: string
  ) {
    const viewState = this.buildViewState(parentItem, parentType, mainType);
    this.setCurrentView(view, viewName, viewState);
  }

  private setCurrentView(
    view: 'buildings' | 'prostorije' | 'jedinice' | 'lokacije',
    viewName: string,
    viewState: any
  ) {
    this.oldView = this.currentView;
    this.oldViewName = this.listViewProvider.viewName;
    this.oldViewState = this.listViewProvider.viewState;

    this.currentView = view;
    this.listViewProvider.viewName = viewName;
    this.listViewProvider.viewState = viewState;
  }

  private buildViewState(
    parentItem: any,
    parentType: string,
    mainType?: string
  ) {
    return {
      $parentId:
        parentItem[
          Util.getFullAttrName(
            parentItem[NtapGlobalConstants.ATTR_$mainType],
            NtapGlobalConstants.ATTR_id
          )
        ],
      $parentType: parentType,
      ...(mainType ? { $mainType: mainType } : {})
    };
  }
}
